var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cta-section"},[_c('div',{staticClass:"cta-content"},[_c('h2',{staticClass:"cta-title"},[_vm._v(" Let’s get started on your New Energy parts. ")]),_c('button',{staticClass:"cta-button",on:{"click":function($event){return _vm.$router.push('/quote')}}},[_vm._v(" Get Instant Quote ")]),_c('div',{staticClass:"mini-text"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }